module.exports = __webpack_public_path__ + "images/equipment_head_1.cb39ae05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/equipment_head_1.png
// module id = 204
// module chunks = 33